<template>
  <div class="coupon-item">
    <div class="left-box">
      <div class="price-box">
        <div class="icon">￥</div>
        <div class="price">{{coupon.cash_reduce / 100}}</div>
      </div>
    </div>
    <div class="right-box">
      <div class="coupon-reach-reduce">
        <span v-if="coupon.reach_reduce">满{{coupon.reach_reduce / 100}}元可用</span>
        <span v-else>无门槛</span>
      </div>

      <div class="time">
        {{formatDate(coupon.start_date, 'YYYY.MM.DD')}}至{{formatDate(coupon.end_date, 'YYYY.MM.DD')}}
      </div>

      <div class="coupon-desc" >
        <div class="text">{{coupon.desc}}</div>
        <div class="desc-tips" @click="$emit('showCouponDescDialog', coupon)" v-if="(coupon.scope === 1 && coupon.countries) || (coupon.scope === 2 && coupon.products)"></div>
      </div>
    </div>

    <img class="icon-received" src="https://o.666visa.cn/static/ssqpeer/homepage/new-people-dialog/coupon-received.png" alt="">

  </div>

</template>

<script>
import dateUtils from '../../../../../libs/date-util';
import CouponDescDialog from '../../../../user/user-children/components/coupon-desc-dialog.vue';

export default {
  components: {
    CouponDescDialog,
  },
  props: {
    coupon: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showCouponDescDialog: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    formatDate: dateUtils.formatDate,
  },
};
</script>

<style lang="less" scoped>
.coupon-item{
  margin: 0 auto;
  width: 400px;
  height: 122px;
  background: url(https://o.666visa.cn/static/ssqpeer/homepage/new-people-dialog/new-people-coupon-bg.png) no-repeat center / 100% 100%;
  display: flex;
  align-items: center;
  line-height: 1;
  margin-bottom: 12px;
  position: relative;
  &:last-child{
    margin-bottom: 0;
  }
  .left-box{
    flex-shrink: 0;
    width: 140px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .price-box{
      display: flex;
      align-items: baseline;
      color: #F43344;
      line-height: 1;
      font-weight: 600;
      .icon{
        font-size: 20px;
      }
      .price{
        font-size: 36px;
      }
    }
  }
  .right-box{
    flex-grow: 1;
    overflow: hidden;
    padding: 22px 18px;
    .coupon-reach-reduce{
      color: #2F333D;
      font-size: 20px;
      line-height: 28px;
      font-weight: 600;
    }
    .time{
      margin-top: 7px;
      color: rgba(113, 119, 133, 0.6);
      font-size: 20px;
    }
    .coupon-desc{
      margin-top: 4px;
      color: rgba(113, 119, 133, 0.6);
      font-size: 20px;
      display: flex;
      align-items: center;
      .text{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .desc-tips{
        flex-shrink: 0;
        margin-left: 6px;
        background: url(https://o.666visa.cn/static/ssqwxa/me/icon-tips.png) no-repeat center / 100% 100%;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }

  }

  .icon-received{
    width: 59px;
    height: 48px;
    position: absolute;
    top: 4px;
    right: 8px;
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/new-people-activity-dialog/components/coupon-item.vue